import React from 'react';

export const EducationGoal = (props) => <BaseGoalIcon color="blue" iconClass={`icon-education ${props.aloneView && 'big'}`} />;

export const PayOffDebtGoal = (props) => <BaseGoalIcon color="steelblue" iconClass={`icon-pay-off-debt ${props.aloneView && 'big'}`} />;

export const SavingsGoal = (props) => <BaseGoalIcon color="purple" iconClass={`icon-piggy ${props.aloneView && 'big'}`} />;

export const FunGoal = (props) => <BaseGoalIcon color="darkblue" iconClass={`icon-fund-fun ${props.aloneView && 'big'}`} />;

export const EmergencyGoal = ({ color, aloneView }) => <BaseGoalIcon color={color} iconClass={`icon-emergency ${aloneView && 'big'}`} />;

export const RainyGoal = ({ color, aloneView }) => <BaseGoalIcon color={color} iconClass={`icon-rainy ${aloneView && 'big'}`} />;

export const CustomGoal = ({ color, aloneView }) => <BaseGoalIcon color={color} iconClass={`icon-default-goal ${aloneView && 'big'}`} />;

// This componnent shows a default icon for goals and default custom icon
// if there is not icon class.
export const BaseGoalIcon = ({ iconClass, color }) => (
  <>
    <div className={`graph-mask dashboard-goal-photo ${color}`}>
      <span className={`icon-svg ${iconClass ?? 'icon-default-goal'}`} />
    </div>
    <div>
      <div className="slice slice-mask">
        <div className="slice-content" />
      </div>
      <div className="slice slice-fill">
        <div className={`slice-content ${color}`} />
      </div>
    </div>
  </>
);
